// @flow
import React, { type Node } from 'react';
import cn from 'classnames';

import { Table, Tr, Td } from 'app/common/ui-components/table';
import type { Discipline } from 'app/dataTypes/Discipline.types';

import styles from './TableSummary.scss';


type Props = {
  className?: string,
  disciplines: Array<Discipline>,
  data: {
    [disciplineId: string]: string,
  },
  onMouseEnterRow: (e: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseLeaveRow: (e: SyntheticMouseEvent<HTMLElement>) => void,
}

const TableSummary = ({
  className,
  disciplines,
  data,
  onMouseEnterRow,
  onMouseLeaveRow,
}: Props): Node => {
  return (
    <Table className={cn(styles.root, className)}>
      <tbody>
        {disciplines.map(({ id }, index) => (
          <Tr
            key={id}
            className={cn(styles.row, `hover_h_${index}`)}
            onMouseEnter={onMouseEnterRow}
            onMouseLeave={onMouseLeaveRow}
          >
            <Td
              className={styles.td}
              stripPadding
            >
              {data[id]}
            </Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableSummary;
